export default __webpack_public_path__ + "static/media/call-white.044a7630.svg";